/*
 * @Author: wangxiaoheng
 * @Date: 2023-04-19 16:52:55
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-12-11 17:32:52
 * @FilePath: \saas_dev\src\utils\v-draggable.js
 * @Description: 
 * 
 * 
 */
import Vue from 'vue'
Vue.directive('draggable', {
  bind(el) {
    let isDragging = false;
    let mouseOffset = { x: 0, y: 0 };
    let iconPosition = { x: 0, y: 0 };

    function startDragging(e) {
      const rect = el.getBoundingClientRect();
      e.stopPropagation();
      isDragging = true;
      mouseOffset.x = getMousePosition(e).x - rect.left;
      mouseOffset.y = getMousePosition(e).y - rect.top;
      iconPosition.x = rect.left;
      iconPosition.y = rect.top;
      addEventListeners();
    }

    function handleDragging(e) {
      if (!isDragging) return;

      // 计算元素新的位置
      const newPosition = calculateNewPosition(e);

      // 获取当前视口的大小
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // 获取元素的宽度和高度
      const elWidth = el.offsetWidth;
      const elHeight = el.offsetHeight;

      // 检查边界
      if (newPosition.x < 0) {
        newPosition.x = 0;
      } else if (newPosition.x + elWidth > viewportWidth) {
        newPosition.x = viewportWidth - elWidth;
      }
      if (newPosition.y < 0) {
        newPosition.y = 0;
      } else if (newPosition.y + elHeight > viewportHeight) {
        newPosition.y = viewportHeight - elHeight;
      }

      // 更新元素的位置
      el.style.left = newPosition.x + 'px';
      el.style.top = newPosition.y + 'px';
      iconPosition = newPosition;
      e.stopPropagation();
      if (e.cancelable) {
        e.preventDefault();
      }
    }

    function stopDragging() {
      isDragging = false;
      removeEventListeners();
    }

    function calculateNewPosition(e) {
      const mousePos = getMousePosition(e);
      const newX = mousePos.x - mouseOffset.x;
      const newY = mousePos.y - mouseOffset.y;
      return { x: newX, y: newY };
    }

    function getMousePosition(e) {
      if (e.changedTouches && e.changedTouches.length) {
        const touch = e.changedTouches[0];
        return { x: touch.clientX, y: touch.clientY };
      } else {
        return { x: e.clientX, y: e.clientY };
      }
    }

    function addEventListeners() {
      el.addEventListener('mousemove', handleDragging);
      el.addEventListener('mouseup', stopDragging);
      el.addEventListener('touchmove', handleDragging, { passive: false });
      el.addEventListener('touchend', stopDragging);
      el.addEventListener('touchend', stopDragging, { passive: false });
    }

    function removeEventListeners() {
      el.removeEventListener('mousemove', handleDragging);
      el.removeEventListener('mouseup', stopDragging);
      el.removeEventListener('touchmove', handleDragging, { passive: false });
      el.removeEventListener('touchend', stopDragging);
    }

    if (!el.__draggable__) {
      el.addEventListener('mousedown', startDragging);
      el.addEventListener('touchstart', startDragging, { passive: true });

      el.style.position = 'fixed';
      el.style.cursor = 'move';

      el.__draggable__ = { addEventListeners, removeEventListeners };
    }
  },

  unbind(el) {
    if (el.__draggable__) {
      const { addEventListeners, removeEventListeners } = el.__draggable__;
      el.removeEventListener('mousedown', addEventListeners);
      el.removeEventListener('touchstart', addEventListeners);
      removeEventListeners();
      delete el.__draggable__;
    }
  },
});
